import styled from "styled-components";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import { useModal } from "../../contexts/ModalContext";

import { GoTrash } from "react-icons/go";
import { useState } from "react";

import useApi from "../../hooks/useApi";
const IconContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(255, 0, 0, 0.3);
    margin: 10px auto;
`
const IconDelete = styled( GoTrash )`
    color: #a50000;
    width: 50%;
    height: 50%;
`
const TextAviso = styled.h2`
    text-align: center;
    margin: 0;
    font-size: 18px;
    font-weight: normal;
    color: #a50000;
`
const TextConfirm = styled.p`
    text-align: center;
    margin: 10px 0;
    font-size: 14px;
    font-weight: normal;
    color: #333;
`
const BotoesContainer = styled.div`
    display: flex;
    width: 100%;
    height: 40px;
    margin-top: 25px;
    justify-content: space-between;
`
const BotaoConfirm = styled.button`
    width: calc( 50% - 5px );
    height: 100%;
    background-color: #DC2625;
    color: white;
    font-size: 14px;
    border: none;
    border-radius: 7px;
    cursor: pointer;
    transition: all.3s;
    &:hover{
        scale: 1.05;
    }
    font-weight: bold;
`
const BotaoCancelar = styled.button`
    width: calc( 50% - 5px );
    height: 100%;
    background-color: #fff;
    color: #333;
    font-size: 14px;
    border: 1px solid rgba(51, 51, 51, 0.4);
    border-radius: 7px;
    cursor: pointer;
    transition: all.3s;
    &:hover{
        scale: 1.05;
    }
    font-weight: bold;
`

const ModalDeleteExame = ({ item, onSuccess }) => {
    const api = useApi();


    const { closeModal } = useModal();

    const [ loading, setLoading ] = useState( false )

    const handleDelete = async () => {

        setLoading( true );

        try{

            const formData = new FormData()
            formData.append( 'id', item.id )

            const { data } = await api.post('/Painel/API/ASO/DeleteExame/', formData)

            console.log( data )

            if( onSuccess ){

                await onSuccess();

            }

            closeModal();

        }catch( e ){

            console.log( e )

        }finally{

            setLoading( false )

        }

    }

    return(
        <>
            <Overlay state={ true } >
                <Modal size="sm" close={ closeModal } >
                    <IconContainer>
                        <IconDelete/>
                    </IconContainer>
                    <TextAviso>Apagar exame</TextAviso>
                    <TextConfirm>Tem certeza que deseja apagar o exame <strong>{ item ? item.exame : '' }</strong>?</TextConfirm>
                    <BotoesContainer>
                        <BotaoCancelar
                            disabled={ loading }
                            onClick={ closeModal }
                        >CANCELAR</BotaoCancelar>
                        <BotaoConfirm
                            onClick={ handleDelete }
                            disabled={ loading }
                        >
                            {
                                loading ? "APAGANDO..." : "APAGAR"
                            }
                        </BotaoConfirm>
                    </BotoesContainer>
                </Modal>
            </Overlay>
        </>
    )

}

export default ModalDeleteExame;